import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class PerformanceService extends AbstractService {

    getPerformances(options) {
        const from = options.from.getFullYear() + '-' + (options.from.getMonth() + 1) + '-' + options.from.getDate();
        const to = options.to.getFullYear() + '-' + (options.to.getMonth() + 1) + '-' + options.to.getDate();

        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + 'bo/performance-records?from=' + from + '&to=' + to + '&search=' + options.search,
        }).then(async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw await responseData.json();
        });
    }

    addPerformance(options) {
        return this.request({
            method: 'POST',
            url:  Facade.getApiRoot() + 'bo/performance-records',
            json: {
                site_id: options.siteId,
                order_count: options.orderCount,
                account_ids_visibility: [],
                date: options.date
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    updatePerformance(options, id) {
        return this.request({
            method: 'PUT',
            url:  Facade.getApiRoot() + 'bo/performance-records/' + id,
            json: {
                order_count: options.orderCount,
                date: options.date
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData;
            }
            throw responseData;
        });
    }

    deletePerformance(id) {
        return this.request({
            method: 'DELETE',
            url:  Facade.getApiRoot() + 'bo/performance-records/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData;
            }
            throw responseData;
        });
    }
}

export default new PerformanceService();
